export const stringSearch = (objects, attributesToSearch, searchTerm) => {
  if (!searchTerm || !attributesToSearch)
    return objects

  if (!Array.isArray(attributesToSearch))
    attributesToSearch = [attributesToSearch]

  if (!objects)
    return []

  if (!Array.isArray(objects))
    objects = [objects] 

  return objects.filter(item =>
    attributesToSearch.some(attribute => {
      const value = typeof attribute === 'function' ? attribute(item) : item[attribute]
      return value && value.toString().toLowerCase().includes(searchTerm.toLowerCase())
    }),
  )
}
